import { useQuery } from '@tanstack/react-query';
import apiClient from "./apiClient";

export interface CheeseItemId {
  id: number;
  fromageNom: string;
  fromageDescription: string;
  laitDescription: string;
  familleDescription: string;
  traitementDescription: string;
  paysDescription: string;
  regionDescription: string;
  quantiteTotale: number;
  quantiteAnnee: number;
  nombreAchat: number;
  nombreAchatAnnee: number;
  dateDernierAchat: string;
  comparables: {
    id: number;
    fromageNom: string;
    clickable: boolean;
  }[];
  observations: {
    observationId: number;
    dateAdded: string;
    observation: string;
  }[];
  accords: {
    accordId: number;
    accordNom: string;
    typeAccordDescription: string;
    typeAccordCategorieDescription: string;
    origineDescription: string;
    numeroSaq: string;
  }[];
  favorite: boolean;
  disliked: boolean;
  subscribed: boolean;
}

const getCheeseById = async (id: number): Promise<CheeseItemId | null> => {
  try {
    const response = await apiClient.get(`/fromages/${id}`);
    return response.data;
  } catch (error) {
    // console.error("Failed to fetch cheese details:", error);
    return null;
  }
};

export const useCheeseById = (id: number) => {
  return useQuery({
    queryKey: ['cheese', id],
    queryFn: () => getCheeseById(id),
    enabled: !!id,
  });
};

export default getCheeseById;
